import debounce from 'lodash/debounce'
import {ensureOk, fancyClient} from '@freckle/educator-entities/ts/openapi-clients'
import {displayNotification} from '@freckle/classroom/ts/common/helpers/helpers'

//
// Have API send a verification email
//
// Throttle to do this only once every 10 min
//
// TODO: swith to server-side throttling
export const resendEmailVerification: (email: string) => void = debounce(
  function (email: string): Promise<void> {
    if (!email) {
      return Promise.resolve(undefined)
    }

    return fancyClient
      .POST('/2/email-verifications', {
        body: {email},
      })
      .then(ensureOk)
      .then(
        () => {
          displayNotification('success', 'Email sent. Please check your inbox.')
        },
        () => {
          displayNotification(
            'error',
            'Could not send email at this point in time, try again later.',
          )
        },
      )
  },
  60 * 1000,
  {leading: true},
)
